import { usePaging } from 'hooks/usePaging';
import { useCallback } from 'react';
import { useGetPermissionsOrganizationUnitsQuery } from 'services';
import { FindAllPermissionOrganizationUnitsDto } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function usePermissionsOrganizationUnits(
  params: Omit<FindAllPermissionOrganizationUnitsDto, 'pageIndex' | 'pageSize'>
) {
  const { pageIndex, resetPage, nextPage } = usePaging(params);
  const {
    data: dataResponse,
    isLoading,
    isFetching
  } = useGetPermissionsOrganizationUnitsQuery({
    pageIndex: pageIndex,
    pageSize,
    ...params
  });

  const { rows, count } = dataResponse?.data || {};

  const hasMore = Boolean(rows && count && rows.length < count);
  const handleLoadMore = useCallback(() => {
    if (hasMore && !isFetching) {
      nextPage();
    }
  }, [hasMore, pageIndex]);

  return {
    organizationUnits: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    resetPage
  };
}
